import React from 'react';
import Text from '../../../Text';
import { dataHooks } from '../../constants';
import { classes } from '../../ListItemAction.st.css.js';
export const Suffix = ({ suffix, size, ellipsis, disabled, }) => {
    return (React.createElement("div", { className: classes.suffixBox },
        React.createElement(Text, { className: classes.suffix, dataHook: dataHooks.suffix, secondary: true, size: size, light: !disabled, weight: "thin", skin: disabled ? 'disabled' : 'standard', ellipsis: ellipsis }, suffix)));
};
//# sourceMappingURL=Suffix.js.map